import { reducer as transactionReducer } from './transactionSlice';

export const mainTransactionReducer = {
  transaction: transactionReducer,
};
